import PropTypes from 'prop-types';
import { linkTicketPhrasesPropTypes } from './link-ticket-module';

export default {
  fullName: PropTypes.string,
  gamesPath: PropTypes.string,
  phrases: PropTypes.exact({
    salutation: PropTypes.string,
    intro: PropTypes.string,
    title: PropTypes.string,
    startButtonLabel: PropTypes.string,
    testCompletionEstimate: PropTypes.string,
    noFullNameGreeting: PropTypes.string,
    returnUser: PropTypes.exact({
      profileButtonLabel: PropTypes.string,
      prompt: PropTypes.string,
    }),
  }),
  linkTickets: PropTypes.shape({
    linkTicketApiPath: PropTypes.string.isRequired,
    redirectTo: PropTypes.string.isRequired,
    phrases: PropTypes.shape(linkTicketPhrasesPropTypes).isRequired,
  }).isRequired,
};
